import {
    useEffect,
    useRef
} from "react";
import type {
    View
} from "react-native";
import type {
    SelectionControlRadioGroupConstantType,
    SelectionControlKeyboardEventType
} from "./type";
import {
    syncSelectionControlRadioGroup,
    getSelectionControlRadioTarget,
    getSelectionControlRadioGroup,
    getSelectionControlRadioStep,
    getSelectionControlElement,
    getSelectionControlRadios
} from "./util";

export const useSelectionControlRadioGroup = ({
    isManaged,
    direction
}: SelectionControlRadioGroupConstantType) => {
    const nodeRef = useRef<View>(null);

    const groupRef = useRef<HTMLElement | null>(null);

    useEffect(() => {
        const element = isManaged ? getSelectionControlElement(nodeRef.current) : null;

        groupRef.current = element ? getSelectionControlRadioGroup(element) : null;

        if(groupRef.current) {
            syncSelectionControlRadioGroup(groupRef.current);
        }
    });

    useEffect(() => {
        return () => {
            if(groupRef.current?.isConnected) {
                syncSelectionControlRadioGroup(groupRef.current);
            }
        };
    }, []);

    const handleKeyDown = (event: SelectionControlKeyboardEventType) => {
        const element = getSelectionControlElement(nodeRef.current);

        const step = getSelectionControlRadioStep({
            key: event.key,
            direction
        });

        if(!isManaged || !element || !step || event.altKey || event.ctrlKey || event.metaKey) {
            return;
        }

        const group = getSelectionControlRadioGroup(element);

        if(!group) {
            return;
        }

        const target = getSelectionControlRadioTarget({
            radios: getSelectionControlRadios(group),
            current: element,
            step
        });

        if(!target) {
            return;
        }

        event.preventDefault();

        target.focus();

        target.click();
    };

    return {
        handleKeyDown,
        nodeRef
    };
};
